import ih from 'immutability-helper';

import * as types from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.ADD_TRACKER_ATTRIBUTE_REQUEST:
      return ih(state, {
        add: {
          isLoading: { $set: true },
        },
      });
    case types.ADD_TRACKER_ATTRIBUTE_SUCCESS:
      return ih(state, {
        add: {
          isLoading: { $set: false },
        },
      });
    case types.ADD_TRACKER_ATTRIBUTE_ERROR:
      return ih(state, {
        add: {
          isLoading: { $set: false },
          error: {
            $set: action.payload.error,
          },
        },
      });
    case types.UPDATE_TRACKER_ATTRIBUTE_REQUEST:
      return ih(state, {
        update: {
          isLoading: { $set: true },
        },
      });
    case types.UPDATE_TRACKER_ATTRIBUTE_SUCCESS:
      return ih(state, {
        update: {
          isLoading: { $set: false },
        },
      });
    case types.UPDATE_TRACKER_ATTRIBUTE_ERROR:
      return ih(state, {
        update: {
          isLoading: { $set: false },
          error: { $set: action.payload.error },
        },
      });
    default:
      return state;
  }
};
